<ng-container *ngIf="isMobile; then mobileHeader; else desktopHeader"></ng-container>

<ng-template #mobileHeader>
  <header>
    <div class="mobile-logo-container">
      <a [href]="marketingLinks.home" target="_blank">
        <img src="/assets/sm-logos/logotype-lake.svg" class="logo" alt="Sondermind logo"
          data-test="sondermind-logo" fetchpriority="low">
      </a>
      <span class="hamburger-menu" data-test="hamburger-menu">
        <iris-icon name="menu" tabindex="0" (click)="toggleMobileMenu()"
          (keydown)="toggleMobileMenuKeyDown($event)"></iris-icon>
      </span>
    </div>

    <div class="mobile-dropdown" [class.show]="showMobileMenu">
      <div class="header-actions">
        <a *ngIf="!hideFindProviderButton" class="nav-link find-a-therapist" [href]="findProviderUrl" target="_blank" data-test="find-therapist-mobile">
          {{ ctaButtonText$ | async }}
        </a>
      </div>
      <a [href]="marketingLinks.whySondermind" target="_blank" data-test="why-sondermind-mobile">
        Why SonderMind
      </a>
      <button class="dropdown-title-mobile" (click)="toggleExploreCare()" data-test="explore-care-mobile">
        Explore Care
        <iris-icon class="caret-mobile" name="expand_more" [color]="iconColors.WHITE"
          [size]="iconSizes.LG" data-test="caret-mobile">
        </iris-icon>
      </button>
      <div *ngIf="showExploreCareMenu" data-test="explore-care-menu-mobile">
        <a [href]="marketingLinks.therapy" target="_blank">Therapy</a>
        <a [href]="marketingLinks.psychiatry" target="_blank">Psychiatry</a>
        <a [href]="marketingLinks.insurance" target="_blank">Insurance</a>
        <a [href]="marketingLinks.articles" target="_blank">Articles and Content</a>
      </div>
      <button class="dropdown-title-mobile" (click)="setShowLoginMenu(!showLoginMenu)" data-test="log-in-mobile">
        Log in
        <iris-icon class="caret-mobile" name="expand_more"
          [color]="(showLoginMenu ? iconColors.HOVER : iconColors.BRAND1)" [size]="iconSizes.LG"
          data-test="caret-mobile">
        </iris-icon>
      </button>
      <div *ngIf="showLoginMenu" data-test="log-in-menu-mobile">
        <a href="{{clientPortalLoginUrl}}" target="_blank">Client login</a>
        <a href="{{providerPortalLoginUrl}}" target="_blank">Therapist login</a>
      </div>
      <a [href]="marketingLinks.realResults" class="nav-link find-a-therapist real-results-link"
        target="_blank" data-test="real-results-mobile">
        Real Results
      </a>
    </div>
  </header>
</ng-template>

<ng-template #desktopHeader>
  <header>
    <div class="header-container">
      <a [href]="marketingLinks.home">
        <img src="/assets/sm-logos/logotype-lake.svg" class="logo" alt="Sondermind logo"
          data-test="sondermind-logo" fetchpriority="low">
      </a>
      <div class="nav-actions-container">
        <nav class="main-nav">
          <a [href]="marketingLinks.whySondermind" target="_blank" (focus)="setExploreCare(false)"
            class="nav-link" data-test="why-sondermind">
            Why SonderMind?
          </a>
          <div class="dropdown" (mouseover)="setExploreCare(true)" (mouseleave)="setExploreCare(false)">
            <button class="nav-link dropdown-toggle" data-test="explore-care" id="dropdownMenuButton"
              (click)="setExploreCare(true)" (focus)="setExploreCare(true)" [attr.aria-expanded]="showExploreCareMenu"
              aria-haspopup="true">
              Explore Care
              <span class="caret">
                <iris-icon name="expand_more"
                  [color]="(showExploreCareMenu ? iconColors.HOVER : iconColors.BRAND1)"
                  [size]="iconSizes.MD"></iris-icon>
              </span>
            </button>
            <div class="dropdown-content long-dropdown" *ngIf="showExploreCareMenu" aria-labelledby="dropdownMenuButton"
              data-test="explore-care-menu">
              <a [href]="marketingLinks.therapy" target="_blank">Therapy</a>
              <a [href]="marketingLinks.psychiatry" target="_blank">Psychiatry</a>
              <a [href]="marketingLinks.insurance" target="_blank">Insurance</a>
              <a [href]="marketingLinks.articles" target="_blank">Articles and
                Content</a>
            </div>
          </div>
          <div class="dropdown" (mouseover)="setShowLoginMenu(true)" (mouseleave)="setShowLoginMenu(false)">
            <button class="nav-link dropdown-toggle" data-test="log-in" id="dropdownMenuButton"
              (click)="setShowLoginMenu(true)" (focus)="setShowLoginMenu(true)" [attr.aria-expanded]="showLoginMenu"
              aria-haspopup="true">
              Log in
              <span class="caret">
                <iris-icon name="expand_more"
                  [color]="(showLoginMenu ? iconColors.HOVER : iconColors.BRAND1)" [size]="iconSizes.MD"></iris-icon>
              </span>
            </button>
            <div class="dropdown-content" *ngIf="showLoginMenu"
              aria-labelledby="dropdownMenuButton" data-test="log-in-menu">
              <a href="{{clientPortalLoginUrl}}" target="_blank">Client login</a>
              <a href="{{providerPortalLoginUrl}}" target="_blank">Therapist login</a>
            </div>
          </div>
        </nav>
        <div class="header-actions">
          <a *ngIf="!hideFindProviderButton" class="nav-link find-a-therapist" [href]="findProviderUrl" target="_blank" (focus)="setExploreCare(false)"
            data-test="find-therapist">
            {{ ctaButtonText$ | async }}
          </a>
        </div>
      </div>
    </div>
  </header>
</ng-template>